import { all, put, select, takeLatest } from 'redux-saga/effects';
import { ClientWalletActionTypes } from './wallet-actions';
import { clientWalletStore } from './wallet-store';
import chargeWalletApi from '@api/financials/charge-wallet';
import { AlertActionType } from '@store/alert/alert-action';
import { homeStore } from '@store/home-screen/home-store';
import getCreditListApi from '@api/clients/wallet/get-credit-list';
import getParseRoute from '@utils/helpers/parse-route';
import getDictionary from '@dictionaries-client';

function* getClientWalletWatcher() {
  const { walletList, currentPage } = yield select(clientWalletStore);
  const { locale } = yield select(homeStore);
  const { api: { client: { wallet: { messages } } } } = getDictionary(locale);
  try {
    const walletListResponse: { data: { data: Array<object>, last_page: number } } = yield getCreditListApi({ page: currentPage, limit: 15, cache: 'no-cache' });
    yield put({
      type: ClientWalletActionTypes.SET_CLIENT_WALLET_LIST,
      data: {
        walletList: [...walletList, ...walletListResponse?.data?.data],
        lastPage: walletListResponse?.data?.last_page,
      },
    });
  } catch (error: any) {
    yield put({
      type: ClientWalletActionTypes.SET_CLIENT_WALLET_LIST,
      data: {
        walletList: walletList,
      },
    });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || messages.default,
      severity: 'danger',
    });
  }
}

function* getClientWalletChargeWatcher() {
  const { walletChargeCredit } = yield select(clientWalletStore);
  const { locale } = yield select(homeStore);
  const { api: { client: { wallet: { messages } } } } = getDictionary(locale);
  try {
    const { navigation, locale } = yield select(homeStore);
    const chargeWalletResponse: { data: { order_id: string } } = yield chargeWalletApi({ credit: walletChargeCredit, cache: 'no-cache' });

    if (chargeWalletResponse?.data?.order_id) {
      if (window.location.pathname.includes('/mobile')) {
        yield navigation.replace(getParseRoute({ pathname: `/mobile/financials/order/${chargeWalletResponse?.data?.order_id}`, locale: locale }));
      } else {
        yield navigation.replace(getParseRoute({ pathname: `/financials/order/${chargeWalletResponse?.data?.order_id}`, locale: locale }));
      }
    } else {
      yield put({
        type: AlertActionType.SHOW_ALERT,
        text: messages.call_support,
        severity: 'danger',
      });
    }
    yield put({ type: ClientWalletActionTypes.SET_CLIENT_WALLET_INITIAL_CHARGE });
  } catch (error: any) {
    yield put({ type: ClientWalletActionTypes.SET_CLIENT_WALLET_INITIAL_CHARGE });
    yield put({
      type: AlertActionType.SHOW_ALERT,
      text: error?.message || messages.default,
      severity: 'danger',
    });
  }
}

function* clientWalletMiddleware() {
  yield all([
    takeLatest(ClientWalletActionTypes.GET_CLIENT_WALLET_LIST, getClientWalletWatcher),
    takeLatest(ClientWalletActionTypes.SET_CLIENT_WALLET_CHARGE, getClientWalletChargeWatcher),
    takeLatest(ClientWalletActionTypes.GET_CLIENT_EXTENDED_WALLET_LIST, getClientWalletWatcher),
  ]);
}

export default clientWalletMiddleware;
